<template>
  <q-card
    :class="['tile border-radius-8 cursor-pointer q-pa-16 text-primary', {
      checked,
    }]"
    bordered
    flat
    @click="onClick"
  >
    <q-img
      :src="`common/transport_types/${type}_small.png?v=2026`"
      :alt="label"
      no-spinner
    />
    <div class="fs-14 text-black text-weight-medium">{{ label }}</div>
    <div :class="['price-block fs-12 text-grey-8', { invisible: !price }]">
      {{ $t('label.price_from') }}
      <span class="price text-weight-medium">{{ price && price.min }}</span>
    </div>
  </q-card>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { tm } = useI18n();

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  price: {
    type: Object,
    default: null,
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const checked = computed(() => props.modelValue.includes(props.type));

const label = computed(() => {
  const text = tm(`transport_types.${props.type}`);

  return text.label || text.common;
});

function onClick() {
  emit('update:modelValue', checked.value ? props.modelValue.filter((el) => props.type !== el) : props.modelValue.concat([props.type]));
}
</script>

<style lang="scss" scoped>
.tile {
  width: 138px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: $grey-2;
    }
  }

  &.checked {
    border-color: currentcolor;
  }

  .q-img {
    height: 67px;
    width: 100px;
  }

  .price {
    color: #31b700;
  }

  @media (min-width: $breakpoint-md-min) and (max-width: $breakpoint-md-max) {
    width: 153px;
  }
}
</style>
